import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "documentId", "form", "title"]

  open(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const documentId = trigger?.dataset?.documentId
    const createUrl = trigger?.dataset?.createUrl
    const formAction = trigger?.dataset?.formAction
    const formMethod = trigger?.dataset?.formMethod
    const formFields = trigger?.dataset?.formFields
    const modalTitle = trigger?.dataset?.modalTitle

    if (this.hasFormTarget) {
      this.formTarget.reset()
      if (formAction || createUrl) {
        this.formTarget.action = formAction || createUrl
      }
      this.applyMethod(this.formTarget, formMethod)
      this.applyFields(this.formTarget, formFields)
    }

    if (this.hasDocumentIdTarget && documentId) {
      this.documentIdTarget.value = documentId
    }

    if (this.hasTitleTarget) {
      const fallbackTitle = this.titleTarget.dataset.defaultTitle || this.titleTarget.textContent
      this.titleTarget.textContent = modalTitle || fallbackTitle
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  applyMethod(form, method) {
    const normalized = (method || "").toLowerCase()
    const existing = form.querySelector("input[name='_method']")
    if (!normalized || normalized === "post") {
      if (existing) {
        existing.remove()
      }
      return
    }

    if (existing) {
      existing.value = normalized
      return
    }

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = normalized
    form.appendChild(methodInput)
  }

  applyFields(form, fields) {
    if (!fields) {
      return
    }

    let parsed = null
    try {
      parsed = JSON.parse(fields)
    } catch (error) {
      parsed = null
    }

    if (!parsed) {
      return
    }

    Object.entries(parsed).forEach(([key, value]) => {
      const input = form.querySelector(`[name="document_part[${key}]"]`)
      if (!input) {
        return
      }

      if (input.type === "checkbox") {
        input.checked = Boolean(value)
      } else {
        input.value = value == null ? "" : String(value)
      }
    })
  }
}
